// New chat — pick an agent from the store and start a thread with it.

import { AgentGrid } from "@/components/chat/agent-grid";
import { useMe } from "@/lib/query/hooks";

export default function ChatHomePage() {
  const { data: me } = useMe();
  const name = me?.email.split("@")[0];
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="mx-auto flex max-w-3xl flex-col px-4 py-16">
        <h1 className="mb-2 text-center text-2xl font-semibold">
          {name ? `Hi ${name}, what can I help with?` : "What can I help with?"}
        </h1>
        <p className="mb-10 text-center text-sm text-muted-foreground">
          Choose an agent to start a conversation.
        </p>
        <AgentGrid limit={6} />
      </div>
    </div>
  );
}
